export default "__VITE_ASSET__f661204f__"